import React from 'react';
import {makeStyles} from 'tss-react/mui';

const SideBar = () => {
  const {classes} = useStyles();
  return <div className={classes.sticky} />;
};

const useStyles = makeStyles()(() => ({
  sticky: {
    position: 'sticky',
    top: 30,
  },
}));

export default SideBar;
